__turbopack_context__.v({
  "mediaButton": "styles-module-scss-module__ZDl-8W__mediaButton",
});
